/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';
import {ActionListModel} from './model/action-list.model';
import {ActivatedRoute, Router} from '@angular/router';
import {ActionListPageService} from './action-list-page.service';

@Component({
  selector: 'well-action-list-page',
  templateUrl: './action-list-page.component.html',
  styleUrls: ['./action-list-page.component.scss']
})
export class ActionListPageComponent {

  @Input() subscriptionTypeUuid: string | undefined = undefined;

  actions: ActionListModel[] = [];
  totalSize = 0;
  event: any = null;
  isAdministrator = true;

  newInputs = false;
  editInputs: boolean | undefined = undefined;
  selectedActionUuid: any | undefined = undefined;

  actionNameList: string[] | undefined = undefined;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private actionListPageService: ActionListPageService,) {
  }

  lazyLoadActions(event: any) {
    if(this.subscriptionTypeUuid) {
      this.event = event;
      this.actionListPageService.getActions(event, this.subscriptionTypeUuid).subscribe(
        res => {
          this.actions = res.data;
          this.totalSize = res.meta.totalSize;
          this.actionNameList = res.meta.actionNameList;
        }
      );
    }
  }

  rowAction(action: any) {
    this.edit(action.rowDataUuid);
  }

  edit(uuid: any) {
    this.selectedActionUuid = uuid;
    this.showEditInputs();
  }

  addNew() {
    this.showNewInputs()
  }

  private showNewInputs() {
    this.newInputs = true;
  }

  private showEditInputs() {
    this.editInputs = true;
  }

  hideNewInputs() {
    this.newInputs = false;
    this.lazyLoadActions(this.event);
  }

  hideEditInputs() {
    this.editInputs = false;
    this.lazyLoadActions(this.event);
  }
}
